import React from 'react';
import { useState, useEffect } from 'react' 
import { Link } from 'react-router-dom';
import { db } from '../../../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';

const Javascript = () => {  
    return (
        <>
            {/* <div className="page-hd clearfix">
                <div className="left-float" style={{marginRight: "20px"}}>
                    <img src="/images/skin1/js-logo.png" /> 
                </div>
                <div className="left-float">
                    <p><strong>Experience: 6.5 Years</strong></p>
                    <p><strong></strong></p>
                </div>
            </div> */}
            <h1>JavaScript <h3>- 7 Years</h3></h1> 
            <ul>
                <li>- Strong understanding of JavaScript, its quirks, and workarounds.</li>
                <li>- Good understanding of asynchronous request handling, partial page updates, and AJAX.</li>
                <li>- Good experience in DOM manipulation.</li>
                <li>- Ability to integrate with JavaScript based frameworks like jQuery, Bootstrap, MaterialUI.</li>
                <li>- Well versed with Object Oriented programming.</li>
                <li>- Strong debugging skills.</li>
            </ul>
        </>
    )

}
export default Javascript;